import ChargeHelper from 'features/Charge/chargeHelper';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

DialogSetChargingPriceView.propTypes = {
    driver: PropTypes.object.isRequired,
    onCancel: PropTypes.func,
    onDone: PropTypes.func,
};

function DialogSetChargingPriceView({ driver, onCancel, onDone }) {
    // MARK: ---- PROPERTIES ----
    const [loading, setLoading] = useState(false);
    const [readyToValidate, setReadyToValidate] = useState(false);
    const [discountType, setDiscountType] = useState('');
    const [discountRate, setDiscountRate] = useState(driver ? driver.discountRate * 100 : 0);

    useEffect(() => {
        if (discountRate === 0) setDiscountType('STANDARD');
        else if (discountRate === 100) setDiscountType('FREE');
        else setDiscountType('DISCOUNT');
    }, [discountRate])
    useEffect(() => {
        if (discountType === 'STANDARD') setDiscountRate(0);
        else if (discountType === 'FREE') setDiscountRate(100);
    }, [discountType])
    // MARK: ---- METHODS ----
    const handleSubmit = async () => {
        setReadyToValidate(true);
        if (Utils.isValid(discountRate) && discountType === 'DISCOUNT') {
            if (discountRate <= 0) {
                ToastHelper.showError('Tỷ lệ chiết khấu phải lớn hơn 0');
                return;
            }
            if (discountRate >= 100) {
                ToastHelper.showError('Tỷ lệ chiết khấu phải nhỏ hơn 100');
                return;
            }
        }
        setLoading(true);
        const res = await ChargeHelper.API.Driver.requestUpdateDriver(
            driver?.userId,
            {
                discountRate: discountRate / 100,
            }
        );
        if (_.isBoolean(res) && res) {
            ToastHelper.showSuccess('Đặt giá sạc xe thành công');
            if (onDone) {
                onDone();
            }
        } else if (_.isString(res)) {
            ToastHelper.showError(res);
        }
        setLoading(false);
    };

    return (
        <div>
            <div className="row m-0 p-0 px-2">
                <div className="col-12 mb-4 px-2">
                    <div>
                        {UIHelper.buildFormLabel('Loại giá sạc', true)}
                        <KTBSDropdown
                            toggleElement={({ showError }) => (
                                <button
                                    className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'border-invalid' : ''}`}
                                    type="button"
                                >
                                    {_.find(
                                        ChargeHelper.Data.chargeDriverPricingTypeOptions,
                                        (item) => item.value === discountType
                                    )?.name ?? 'Chọn loại giá sạc'}
                                </button>
                            )}
                            selectedValue={discountType}
                            dropdownMenuItems={ChargeHelper.Data.chargeDriverPricingTypeOptions}
                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                            dropdownMenuClassName="overflow-auto w-100"
                            onChange={(value) => setDiscountType(value)}
                            enableCheckValid
                            isDropdownForm={true}
                        />
                    </div>
                </div>
                {discountType === 'DISCOUNT' && (
                    <div className="col-12 mb-4 px-2">
                        {UIHelper.buildFormLabel('Tỷ lệ chiết khấu', true)}
                        <KTFormInput
                            type={KTFormInputType.number}
                            placeholder="Nhập tỷ lệ chiết khấu"
                            name="discountRate"
                            value={discountRate}
                            unit='%'
                            onChange={(value) => {
                                setDiscountRate(value);
                            }}
                            enableCheckValid={readyToValidate}
                            isValid={
                                discountRate > 0 && discountRate < 100
                            }
                            checkValidInput={(value) => {
                                return value === '' || /^\d+(\.\d{0,1})?$/.test(value)
                            }}
                            isTouched={readyToValidate}
                            feedbackText={discountType === 'DISCOUNT'
                                ? discountRate <= 0
                                    ? 'Tỷ lệ chiết khấu phải lớn hơn 0%'
                                    : discountRate >= 100
                                        ? 'Tỷ lệ chiết khấu phải nhỏ hơn 100%'
                                        : ''
                                : ''}
                        />
                    </div>
                )}
            </div>

            {/* footer */}
            <div
                className="d-flex align-items-center justify-content-end gap-3 p-3"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
            >
                {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null, true)}
                {UIHelper.buildGreenButton('Xác nhận', handleSubmit, null, true, loading)}
            </div>
        </div>
    );
}

export default DialogSetChargingPriceView;
